import ImageCarousel from '../../components/ImageCarousel/ImageCarousel';
import styles from './Carousel.module.css';

function Carousel({ images = [], alt = '' }) {
  return (
    <div className={styles.wrapper}>
      <ImageCarousel images={images} alt={alt} />
    </div>
  );
}

export default Carousel;
